module.exports = __webpack_public_path__ + "static/balenaBlog-8365c577ee0d140c6291f74a791745ce.svg";